<template>
    <div class="header">
        <div class="heade_content">
            <!-- 导航 -->
            <div class=" title ">
                <img class="hidden" @click="expands()" style="width:20px;height:20px;margin-right:10px"
                    src="../assets/img/expand.png" alt="">
                {{ $t(store.state.activeName) }}
            </div>
            <!-- 设置 -->
            <div class="flex-end flex-1-1 w-170">
                <!-- <div
                    style="height: 36px;margin: 0px 4px 0px 0px;padding: 6px 15px;display: flex;align-items: center; cursor: pointer;">
                    <img style="width:20px;height: 20px;" src="../assets/img/sun.png" />
                </div> -->
                <div class="m-r-5">
                    <el-button size="small" plain @click="jump()">{{ $t("header.official_website") }}</el-button>
                </div>
                <div>
                    <el-dropdown trigger="click">
                        <el-button type="primary" size="small" style="font-weight: 600;">
                            {{ $t("header.language") }}
                        </el-button>
                        <template #dropdown>
                            <el-dropdown-menu>
                                <el-dropdown-item @click="changelanguage('en')">English</el-dropdown-item>
                                <!-- <el-dropdown-item @click="changelanguage('chinese')">简体中文</el-dropdown-item> -->
                                <el-dropdown-item @click="changelanguage('por')">Portuguese</el-dropdown-item>
                            </el-dropdown-menu>
                        </template>
                    </el-dropdown>
                </div>
                <div>
                    <el-dropdown trigger="click">
                        <el-button type="primary" size="small" style="font-weight: 600;">
                            <span class="show">{{ email }}</span>
                            <img class="hidden" style="width: 20px;height: 20px;" src="../assets/img/reducePeron.png"
                                alt="" />
                            <el-icon class="el-icon--right show">
                                <arrow-down />
                            </el-icon>
                        </el-button>
                        <template #dropdown>
                            <el-dropdown-menu>
                                <el-dropdown-item @click="person()">{{ $t("header.user_enter") }}</el-dropdown-item>
                                <el-dropdown-item @click="logOut()">{{ $t("header.sign_out") }}</el-dropdown-item>
                            </el-dropdown-menu>
                        </template>
                    </el-dropdown>
                </div>
            </div>
        </div>
        <div>
            <el-drawer v-model="drawer" direction="ltr" size="80%" :show-close="false">
                <template #header="{ close }">
                    <div>
                        <span @click="goHome()" style="cursor: pointer;">Mute-Cs</span>
                    </div>
                    <el-icon @click="close">
                        <CircleCloseFilled />
                    </el-icon>
                </template>
                <div class="h-full">
                        <aside-component @asideCose="asideClose" />
                </div>
            </el-drawer>
        </div>
    </div>
</template>
<script>
import { ArrowDown, CircleCloseFilled } from '@element-plus/icons-vue'
import AsideComponent from './AsideComponent.vue'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex';

export default {
    setup() {
        const { locale } = useI18n()
        const store = useStore();
        let changelanguage = (lang) => {
            if (lang === 'zh') {
                locale.value = 'zh'
                sessionStorage.setItem('lang', 'zh')
            } else if (lang === 'en') {
                locale.value = 'en'
                sessionStorage.setItem('lang', 'en')
            } else {
                locale.value = 'por'
                sessionStorage.setItem('lang', 'por')
            }
            // window.location = window.location.href;
        }
        //监视属性
        return { locale, changelanguage, store }
    },
    components: { ArrowDown, AsideComponent, CircleCloseFilled },
    data() {
        return {
            email: '',
            drawer: false,
        }
    },
    methods: {
        logOut() {
            sessionStorage.clear();
            localStorage.clear();
            this.$router.push('/login');
        },
        // 点击方法 url为传入的第三方链接或网址 如'www.baidu.com' url前面不要加协议哦！23.94.27.194/:9003
        jump() {
            window.location.href =window.ipConfig.webUrl;
        },
        expands() {
            this.drawer = true;
        },
        goHome() {
            this.$router.push('/login');
        },
        asideClose() {
            this.drawer = false;
        },
        person() {
            this.store.commit('updateActiveName', 'header.user_enter');
            this.store.commit('updateActivePath', '/person');
            this.$router.push('/person');
        },

    },
    created() {
        this.email = sessionStorage.getItem('email')
    },

}
</script>
<style scoped>
.example-showcase .el-dropdown-link {
    cursor: pointer;
    color: var(--el-color-primary);
    display: flex;
    align-items: center;
}

.header {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    /* min-width: 683px; */
}

.heade_content {
    width: 100%;
    max-width: 1200px;
    display: flex;
    justify-content: space-between;
}

.title {
    font-size: 16px;
    color: white;
    align-content: center;
    align-items: center;
    display: flex;
    min-width: 100px;
}

.setting {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    color: white;
    font-weight: 600;
    align-items: center;
    min-width: 150px;
}
</style>